import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Logo from '../Logo'

export default function Nav() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header className="sticky top-0 z-50 pt-3.5">
      <div className="mx-auto max-w-6xl px-4">
        <nav className="relative flex items-center justify-between gap-4 rounded-full py-2 pl-4 pr-2.5">
          <div
            aria-hidden
            className={`absolute inset-0 -z-10 rounded-full border border-white/[0.14] bg-[rgb(24_28_37/0.62)] shadow-[0_12px_40px_-18px_rgb(0_0_0/0.7)] backdrop-blur-2xl transition-opacity duration-200 ${
              scrolled ? 'opacity-100' : 'opacity-0'
            }`}
          />
          <Link
            to="/"
            aria-label="notes2board home"
            className="rounded-full transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
          >
            <Logo size="sm" tone="dark" />
          </Link>
          <div className="flex items-center gap-1">
            <Link
              to="/auth"
              className="rounded-full px-3 py-2.5 text-body text-white/60 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
            >
              Sign in
            </Link>
            <Link
              to="/auth"
              className="inline-flex items-center rounded-full bg-white px-4 py-2.5 text-body font-medium text-surface-base transition-[transform,opacity] duration-150 ease-out hover:opacity-90 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-surface-base"
            >
              Get started
            </Link>
          </div>
        </nav>
      </div>
    </header>
  )
}
